var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHackathon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 200,
    viewBox: "0 0 75 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_1132)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1326_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 188V12C0 5.37258 5.37259 0 12 0H63C69.6274 0 75 5.3726 75 12V165.184C75 167.771 74.1643 170.288 72.6175 172.361L55.5923 195.177C53.3273 198.212 49.7622 200 45.9748 200H12C5.37258 200 0 194.627 0 188Z",
    fill: "#282828",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 188V12C0 5.37258 5.37259 0 12 0H63C69.6274 0 75 5.3726 75 12V165.184C75 167.771 74.1643 170.288 72.6175 172.361L55.5923 195.177C53.3273 198.212 49.7622 200 45.9748 200H12C5.37258 200 0 194.627 0 188Z",
    fill: "url(#paint0_linear_1326_1132)",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 188V12C0.5 5.64873 5.64873 0.5 12 0.5H63C69.3513 0.5 74.5 5.64874 74.5 12V165.184C74.5 167.663 73.6991 170.075 72.2168 172.062L55.1916 194.878C53.0209 197.787 49.6044 199.5 45.9748 199.5H12C5.64872 199.5 0.5 194.351 0.5 188Z",
    stroke: "url(#paint1_linear_1326_1132)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.674 157.157L27.674 159.677L35.102 159.677L35.102 168.917L27.674 168.917L27.674 171.437L44.834 171.437L44.834 168.917L37.442 168.917L37.442 159.677L44.834 159.677L44.834 157.157L27.674 157.157ZM36.212 155.465L36.212 153.035C34.544 153.035 33.446 151.925 33.446 149.483C33.446 147.089 34.808 145.589 36.986 145.589L37.292 145.589L37.292 150.695C37.292 153.887 38.786 155.855 41.204 155.855C43.598 155.855 45.194 153.929 45.194 151.037C45.194 148.247 43.712 146.231 41.276 145.589L44.834 145.589L44.834 143.159L36.986 143.159C33.392 143.159 31.244 145.523 31.244 149.441C31.244 153.143 33.17 155.465 36.212 155.465ZM39.332 145.589L39.698 145.589C41.672 145.589 43.076 147.575 43.076 150.383C43.076 152.363 42.38 153.455 41.12 153.455C39.956 153.455 39.332 152.507 39.332 150.719L39.332 145.589ZM38.216 139.402C35.258 139.402 33.44 137.86 33.44 135.358C33.44 133.162 34.844 131.998 36.59 131.68L36.59 129.25C33.584 129.64 31.244 131.812 31.244 135.364C31.244 139.24 34.034 141.832 38.216 141.832C42.398 141.832 45.194 139.24 45.194 135.364C45.194 131.812 42.854 129.646 39.848 129.25L39.848 131.68C41.594 132.004 42.998 133.168 42.998 135.358C42.998 137.86 41.174 139.402 38.216 139.402ZM31.604 116.03L31.604 119.15L37.484 125.444L27.074 125.444L27.074 127.874L44.834 127.874L44.834 125.444L39.356 125.444L44.834 118.874L44.834 115.394L38.366 123.404L31.604 116.03ZM36.212 115.334L36.212 112.904C34.544 112.904 33.446 111.794 33.446 109.352C33.446 106.958 34.808 105.458 36.986 105.458L37.292 105.458L37.292 110.564C37.292 113.756 38.786 115.724 41.204 115.724C43.598 115.724 45.194 113.798 45.194 110.906C45.194 108.116 43.712 106.1 41.276 105.458L44.834 105.458L44.834 103.028L36.986 103.028C33.392 103.028 31.244 105.392 31.244 109.31C31.244 113.012 33.17 115.334 36.212 115.334ZM39.332 105.458L39.698 105.458C41.672 105.458 43.076 107.444 43.076 110.252C43.076 112.232 42.38 113.324 41.12 113.324C39.956 113.324 39.332 112.376 39.332 110.588L39.332 105.458ZM44.732 93.458L42.632 93.458C42.902 94.472 43.028 95.228 43.028 95.786C43.028 97.202 42.212 97.838 40.46 97.838L33.644 97.838L33.644 93.458L31.604 93.458L31.604 97.838L28.556 97.838L28.556 100.268L31.604 100.268L31.604 102.068L33.644 102.068L33.644 100.268L40.454 100.268C43.562 100.268 45.188 98.828 45.188 96.194C45.188 95.39 45.038 94.478 44.732 93.458ZM37.676 89.5542C35 89.5542 33.44 88.0962 33.44 85.6542C33.44 83.3862 34.784 82.2582 37.436 82.2582L44.834 82.2582L44.834 79.8282L37.436 79.8282C33.596 79.8282 31.244 81.6342 31.244 84.6462C31.244 87.1122 32.822 88.9122 35.426 89.5542L27.074 89.5542L27.074 91.9842L44.834 91.9842L44.834 89.5542L37.676 89.5542ZM38.216 78.5086C42.398 78.5086 45.194 75.9166 45.194 72.0406C45.194 68.1646 42.398 65.5726 38.216 65.5726C34.034 65.5726 31.244 68.1646 31.244 72.0406C31.244 75.9166 34.034 78.5086 38.216 78.5086ZM38.216 76.0786C35.264 76.0786 33.44 74.5366 33.44 72.0346C33.44 69.5386 35.258 68.0026 38.216 68.0026C41.174 68.0026 42.998 69.5386 42.998 72.0346C42.998 74.5366 41.174 76.0786 38.216 76.0786ZM37.676 61.7686C35 61.7686 33.44 60.3106 33.44 57.8686C33.44 55.6006 34.784 54.4726 37.436 54.4726L44.834 54.4726L44.834 52.0426L37.436 52.0426C33.596 52.0426 31.244 53.8426 31.244 56.8606C31.244 59.3266 32.822 61.1266 35.426 61.7686L31.604 61.7686L31.604 64.1986L44.834 64.1986L44.834 61.7686L37.676 61.7686ZM44.834 26.6157L42.494 26.6157L42.494 37.5717C40.106 37.5057 39.452 35.2077 38.9 33.2577L38.594 32.1957C37.904 29.7657 36.998 26.5617 33.032 26.5617C29.612 26.5617 27.314 28.9377 27.314 33.0777C27.314 37.3497 29.762 39.9837 33.626 39.9837L33.992 39.9837L33.992 37.4637L33.674 37.4637C31.286 37.4637 29.66 35.7897 29.66 33.2157C29.66 30.7077 31.19 29.0817 33.068 29.0817C35.252 29.0817 35.81 30.9297 36.536 33.3477L36.776 34.1517C37.55 36.7257 38.552 40.0617 42.596 40.0617L44.834 40.0617L44.834 26.6157Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1326_1132",
    x: -148,
    y: -156,
    width: 395,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1326_1132"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1326_1132",
    result: "effect2_dropShadow_1326_1132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1326_1132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_1132",
    x1: 37.5,
    y1: 0,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB1BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1326_1132",
    x1: -45.5,
    y1: 224,
    x2: 124.5,
    y2: -41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB1BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackathon2);
export default __webpack_public_path__ + "static/media/Hackathon2.2f304b121341bb5e367ef54493800221.svg";
export { ForwardRef as ReactComponent };